import { render, staticRenderFns } from "./Personalcenter.vue?vue&type=template&id=160fb3e6&scoped=true&"
import script from "./Personalcenter.vue?vue&type=script&lang=js&"
export * from "./Personalcenter.vue?vue&type=script&lang=js&"
import style0 from "./Personalcenter.vue?vue&type=style&index=0&id=160fb3e6&scoped=true&lang=css&"
import style1 from "./Personalcenter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160fb3e6",
  null
  
)

export default component.exports